export function measures(state, data) {
  state.measures = data
}

export function tyreCategories(state, data) {
  state.tyreCategories = data
}
